import { Center, Loader } from "@mantine/core";

import { safeApiCall } from "api/common.service";
import { getCustomerOrderHistory } from "api/report.service";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RptCustomerOrderHistories } from "types/model.types";

const CustomerOrderHistoryPreview: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<RptCustomerOrderHistories | null>();

  const [params] = useSearchParams();
  const id = params.get("id");
  const year = params.get("y");

  useEffect(() => {
    if (!id) return;
    let mounted = true;

    const fetchData = async () => {
      try {
        const result = await safeApiCall(
          getCustomerOrderHistory(
            Number(id),
            Number(year ?? new Date().getFullYear()),
          ),
        );
        if (mounted && result) setData(result?.data ?? []);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }
  return (
    <div>
      <div className="sub-title">Customer Order History Report</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Debtor #</th>
            <th>Product Code</th>
            <th>Month</th>
            <th>Year</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((row, index) => (
              <tr key={`${index}-${row.id}`}>
                <td>{row.id}</td>
                <td>{row.productId}</td>
                <td>{row.monthName}</td>
                <td>{row.yearOrdered}</td>
                <td>{row.total}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerOrderHistoryPreview;
